import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatNumbers' })
export class FormatNumbersPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value.replace(/\d+/g, n => Number(n).toLocaleString('en-US'));
  }
}
